/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { FillingStationAreaModel } from './fillingstationarea';
import { FillingStationArea } from './fsa';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class FillingStationAreaService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allData(data): Promise<FillingStationAreaModel[]> {
        return this.httpmanagerService.HttpPost('sfillingstationarea/alldata', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    searcharealist(data): Promise<FillingStationAreaModel[]> {
        return this.httpmanagerService.HttpPost('sfillingstationarea/searcharealist', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    SaveFillingStationArea(data): Promise<FillingStationArea> {
        return this.httpmanagerService.HttpPost('sfillingstationarea/create', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    UpdateFillingStationArea(id, data): Promise<FillingStationArea> {
        return this.httpmanagerService.HttpPut('sfillingstationarea', JSON.stringify(data), id).then(data => {
            return data;
        })
    }
    SearchFillingStation(data): Promise<FillingStationAreaModel[]> {
        return this.httpmanagerService.HttpPost('sfillingstationarea/searchfillingstation', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    GetFillingStationByAreaId(data): Promise<FillingStationAreaModel[]> {
        return this.httpmanagerService.HttpPost('sfillingstationarea/getfillingstationbyareaid', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    LinkFillingStationIntoArea(data): Promise<FillingStationArea> {
        return this.httpmanagerService.HttpPost('sfillingstationarea/linkfillingstationintoarea', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    UnlinkFillingStationIntoArea(data): Promise<FillingStationArea> {
        return this.httpmanagerService.HttpPost('sfillingstationarea/unlinkfillingstationintoarea', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/fillingstationarea/fillingstationarea.service.ts